import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { PermissionValidationSchema } from '@/features/permissions/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateTmaisPermissionProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useCreateTmaisPermission = ({ onSuccess, onError }: UseCreateTmaisPermissionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createTmaisPermission'],
    mutationFn: async (form: PermissionValidationSchema) => {
      const parsedProperties = form.properties && JSON.parse(form.properties?.replace(/'/g, '"'));

      const permission = {
        ...form,
        operation_klass: form.operation_klass.value,
        properties: parsedProperties
      }

      return privateAxios.post('/tmais/permissions', permission)
    },
    onSuccess,
    onError,
  })
}

export default useCreateTmaisPermission
